exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".statistic-chat h3 {\n  font-size: 30px;\n  border-bottom: 1px solid #ccc;\n  margin: 0 0 20px 0;\n}\n.statistic-chat p {\n  font-size: 20px;\n}\n.statistic-chat p span {\n  font-weight: bold;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-oneOf-3-1!./node_modules/less-loader/dist/cjs.js??ref--1-oneOf-3-2!./src/components/Modules/Statistics/StatisticChat/statisticChat.less
// module id = 1500
// module chunks = 0